/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Chip, Tooltip, Typography } from '@mui/material';
import { copyText } from './mavenUtils';

/** "Proof:" chips with the full request ids behind the answer; a click copies the id. */
const AnswerProof = ({ requestIds }) => {
  const [copiedId, setCopiedId] = useState(null);
  if (!requestIds.length) return null;
  const copy = (id) => {
    copyText(id);
    setCopiedId(id);
  };
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center', mt: 1 }}>
      <Typography variant="caption" sx={{ mr: 0.5 }}>
        Proof:
      </Typography>
      {requestIds.map((id) => (
        <Tooltip key={id} title={copiedId === id ? 'Copied' : 'Copy request id'}>
          <Chip
            size="small"
            variant="outlined"
            label={id}
            onClick={() => copy(id)}
            onMouseLeave={() => setCopiedId(null)}
            sx={{ fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace', fontSize: 11, maxWidth: '100%' }}
          />
        </Tooltip>
      ))}
    </Box>
  );
};

AnswerProof.propTypes = { requestIds: PropTypes.arrayOf(PropTypes.string).isRequired };

export default AnswerProof;
